<template>
  <!--Extras Case-1-->
  <div
    id="modalExtrasRequired"
    class="modal s-modal s-modal--warning"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-warning"></i></div>
            <div>{{ dictionary.modalExtrasTitle }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="onClickUndo">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body">
          <!-- <div class="mb-20">1 selected: {{ selected }}</div> -->

          <!-- included childs -->
          <div
            v-if="childsIncluded.length"
            :class="{ 'mb-30': childsRequired.length }">
            <p>{{ dictionary.modalExtrasIncludedText }}</p>

            <ul class="b-extras-as-badges-list">
              <li v-for="(item, index) in childsIncludedFlat" :key="index">
                <div class="e-extra-as-badge">
                  <span>{{ getExtraName(item) }}</span>
                </div>
              </li>
            </ul>
          </div>

          <!-- required childs -->
          <div v-if="childsRequired.length">
            <div>
              <p>{{ dictionary.modalExtrasRequiredText }}</p>
            </div>

            <ul class="b-extras-as-badges-groups">
              <li v-for="(array, index) in childsRequired" :key="index">
                <ExtrasGroupRequired
                  :records="array"
                  :options="options"
                  :group-index="index"
                  :selected-options="selectedOptions"
                  @change-selected="onChangeSelected" />
                <i
                  v-if="index < childsRequired.length - 1"
                  class="icon-addthis"></i>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <ul>
            <li>
              <button
                type="button"
                class="btn btn-outline-danger btn-full-width"
                data-bs-dismiss="modal"
                @click="onClickUndo">
                {{ dictionary.modalExtrasButtonCancelText }}
              </button>
            </li>
            <li>
              <button
                type="button"
                class="btn btn-primary btn-full-width"
                data-bs-dismiss="modal"
                @click="onClickSubmit">
                {{ dictionary.modalExtrasButtonSubmitText }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'

import ExtrasGroupRequired from './ExtrasGroupRequired.vue'
/* eslint-disable no-unused-vars */
import { remove } from 'lodash'

export default {
  components: { ExtrasGroupRequired },
  props: {
    master: {
      required: false,
      type: String,
      default: '',
    },
    childsIncluded: {
      required: false,
      type: Array,
      default: () => [],
    },
    childsRequired: {
      required: false,
      type: Array,
      default: () => [],
    },
    options: {
      required: true,
      type: Array,
    },
    selectedOptions: {
      required: true,
      type: Array,
    },
  },
  emits: ['submit', 'undo'],
  data() {
    return {
      selected: [],
    }
  },
  // watch: {
  //   childsIncluded(newValue) {
  //     this.selected = this.selected.concat(newValue)
  //   },
  //   childsRequired(newValue) {
  //     newValue.forEach((element) => {
  //       this.selected.push(element[0])
  //     })
  //   },
  // },
  computed: {
    childsIncludedFlat() {
      return lib.flatten(this.childsIncluded)
    }
  },
  mounted() {
    // included
    this.selected.push(...lib.flatten(this.childsIncluded))
    // required
    this.selected.push(...lib.flatten(this.childsRequired))
  },
  methods: {
    getExtraName(value) {
      return this.options.find((x) => x.optionId === value).name
    },
    onChangeSelected(newValue, oldValue) {
      /* eslint-disable no-undef */
      this.selected = _.remove(this.selected, (x) => x !== oldValue)

      if (!this.selected.includes(newValue)) {
        this.selected.push(newValue)
      }
    },

    onClickUndo() {
      this.$emit('undo', this.master)
    },

    onClickSubmit() {
      this.$emit('submit', this.selected)
    },
  },
}
</script>
